const SIZE_OF_SYMBOLS = 512;

export const cutTheText = (text: string) => {
  return text.length <= SIZE_OF_SYMBOLS ? text : text.substring(0, SIZE_OF_SYMBOLS + 1) + '...';
};
